import React from 'react';
import { getNavIconClass } from '../../../navigation/clinicNavConfig';

function TemplatesNav({ tabs, activeTab, onTabChange }) {
    return (
        <nav className="templates-tab-nav" role="tablist" aria-label="Template sections">
            <div className="templates-tab-nav__track">
                {tabs.map((tab) => {
                    const isActive = activeTab === tab.id;

                    return (
                        <button
                            key={tab.id}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            className={`templates-tab-nav__pill templates-tab-nav__pill--${tab.theme} ${
                                isActive ? 'is-active' : ''
                            }`}
                            onClick={() => onTabChange(tab.id)}
                        >
                            <span
                                className={`templates-tab-nav__pill-icon ecx-nav-icon ${getNavIconClass(tab.theme)}`}
                            >
                                <i className={`bi ${tab.icon}`}></i>
                            </span>
                            <span className="templates-tab-nav__pill-label">{tab.label}</span>
                        </button>
                    );
                })}
            </div>
        </nav>
    );
}

export default TemplatesNav;
